import Cookies from 'js-cookie'
import constants from '../../api/constants'

const state = {
    sidebar: {
        opened: function () {
            if (typeof Constants.AdminConsole.Sidebar.OpenStatusFromCookie != 'undefined' && Constants.AdminConsole.Sidebar.OpenStatusFromCookie === true) {
                return Cookies.get('sidebarStatus') ? !! +Cookies.get('sidebarStatus') : true;
            } else {
                return true;
            }
        },
        withoutAnimation: false
    },
    theme: Cookies.get('theme') || 'theme-darkblue',
    device: 'desktop',
    adminLayoutMode: Cookies.get('ADMIN_LAYOUT_MODE') ? Cookies.get('sidebarStatus') : constants.AdminLayoutMode_Default,
    size: Cookies.get('size') || 'medium'
}

const mutations = {
    TOGGLE_SIDEBAR: (state, showOrHide) => {
        let opended = (typeof showOrHide == 'undefined') ? !state.sidebar.opened : showOrHide;
        state.sidebar.opened = opended;
        state.sidebar.withoutAnimation = false
        if (state.sidebar.opened) {
            Cookies.set('sidebarStatus', 1)
        } else {
            Cookies.set('sidebarStatus', 0)
        }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
        Cookies.set('sidebarStatus', 0)
        state.sidebar.opened = false
        state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
        state.device = device
    },
    SET_LANGUAGE: (state, language) => {
        state.language = language
        Cookies.set('language', language)
    },
    SET_SIZE: (state, size) => {
        state.size = size
        Cookies.set('size', size)
    },
    ADMIN_LAYOUT_MODE: (state, mode) => {
        state.adminLayoutMode = mode
        Cookies.set(state, mode)
    },
    SET_THEME: (state, theme) => {
        Cookies.set('theme', theme);
        document.getElementsByTagName('body')[0].style.setProperty('--el-color-primary', 'red');
    }
}

const actions = {
    toggleSideBar({ commit }, showOrHide) {
        commit('TOGGLE_SIDEBAR', showOrHide);
    },
    closeSideBar({ commit }, { withoutAnimation }) {
        commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
        commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
        commit('SET_LANGUAGE', language)
    },
    setSize({ commit }, size) {
        commit('SET_SIZE', size)
    },
    setAdminLayoutMode({ commit }, mode) {
        commit('ADMIN_LAYOUT_MODE', mode)
    },
    changeTheme({ commit }, theme) {
        return new Promise((resolve, reject) => {
            commit("SET_THEME", theme);
            resolve();
        });
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}